import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default [
  {
    exact: true,
    path: '/home/safe/dataRole/new',
    owner: '/home',
    authority: 'dataRole',
    component: Loadable({
      loader: () => import('./new'),
      loading: () => <RouteLoading />
    })
  },{
    exact: true,
    path: '/home/safe/dataRole/mod/:id',
    owner: '/home',
    authority: 'dataRole',
    component: Loadable({
      loader: () => import('./mod'),
      loading: () => <RouteLoading />
    })
  }
];